"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTooltip = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const ICONS = {
    questionMark: polaris_icons_1.QuestionCircleIcon
};
const IconTooltip = ({ content, icon = 'questionMark', iconTone = 'base' }) => {
    return (react_1.default.createElement(polaris_1.Tooltip, { content: content },
        react_1.default.createElement(polaris_1.Icon, { source: ICONS[icon], tone: iconTone })));
};
exports.IconTooltip = IconTooltip;
